<template>
	<van-popup v-model="show" class="login-popup" round>
		<div class="login-container">
			<div class="login-header">
				<img src="https://sweetour-pic.obs.cn-north-1.myhuaweicloud.com/20251127.4.png" alt="">
			</div>
			<div class="login-form">
				<div class="login-field">
					<!-- <p>请输入手机号码</p> -->
					<input v-model="phone" type="tel" maxlength="11" placeholder="请输入手机号码">
				</div>
				<div class="login-field code-field">
					<!-- <p>短信验证码</p> -->
					<div class="code-input">
						<input v-model="code" type="number" maxlength="6" placeholder="请输入验证码">
						<button class="code-btn" :disabled="countDown > 0"
							@click="onGetCode">{{ countDown > 0 ? countDown + 's' : '获取验证码' }}</button>
					</div>
				</div>
				<button class="login-btn" @click="onSubmit">登录</button>
				<!-- <div class="login-agree">
					<label>
						<input v-model="checked" type="checkbox">
						<span>我已阅读并同意《用户服务协议》及《隐私政策》</span>
					</label>
				</div> -->
				<div class="login-cancel" @click="onCancel">暂不注册</div>
			</div>
		</div>
	</van-popup>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	import {
		Toast
	} from 'vant'
	export default {
		name: 'Login',
		props: {
			value: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				phone: '',
				code: '',
				checked: false,
				countDown: 0,
				timer: null
			}
		},
		computed: {
			show: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('input', val)
				}
			}
		},
		methods: {
			...mapMutations('account', ['setUserInfo', 'setUserTokenNew']),
			validatePhoneNumber(tel) {
				let reg =
					/^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/
				return reg.test(tel)
			},
			onGetCode() {
				if (!this.phone) {
					Toast('请输入手机号码')
					return
				}
				if (!this.validatePhoneNumber(this.phone)) {
					Toast('请输入正确的手机号码')
					return
				}
				if (this.countDown > 0) return

				const sign = this.$md5(this.phone + "928ca249aa1d894cb11a992bc216248d639211b6").toUpperCase()

				this.$post(this.$login + "/DouYin/SendCodeMsg", {
					phone: this.phone,
					sign: sign,
					pt: this.$organizationId
				}).then(res => {
					// 假设接口返回 true 或者 success 字段，根据实际情况调整
					// 如果 res 本身就是 boolean 或者包含 code
					console.log('SendCodeMsg res:', res)
					if (res.err_no < 1) {
						Toast('发送成功')
						this.startTimer()
					} else {
						Toast('发送失败')
					}
				}).catch(err => {
					console.error(err)
					Toast('发送失败，请稍后重试')
				})
			},
			startTimer() {
				this.countDown = 60
				this.timer = setInterval(() => {
					this.countDown--
					if (this.countDown <= 0) {
						clearInterval(this.timer)
						this.timer = null
					}
				}, 1000)
			},
			onSubmit() {
				if (!this.phone) {
					Toast('请输入手机号码')
					return
				}
				if (!this.validatePhoneNumber(this.phone)) {
					Toast('请输入正确的手机号码')
					return
				}
				if (!this.code) {
					Toast('请输入验证码')
					return
				}
				var _this = this
				this.$post(this.$login + '/DouYin/CheckCodeMsg', {
					phone: this.phone,
					code: this.code
				}).then(res => {
					console.log('CheckCodeMsg res:', res)
					if (res.err_no < 1) {
						var jsonData = {
							"mobile": this.phone,
							"orgId": this.$organizationId,
							"openId": localStorage.getItem("openId")
						}
						this.$post(this.$login + '/abc/login', jsonData).then(res => {
							var users = res.userData
							users.openid = res.wxData.openid
							// alert(JSON.stringify(users))
							Toast('登录成功')
							this.setUserInfo(users)
							this.getTokenNew(res.userData.userId)
							this.show = false
						})
					} else {
						Toast(res.err_tips)
					}
				}).catch(err => {
					console.error(err)
					Toast('验证失败，请稍后重试')
				})
			},
			onCancel() {
				this.show = false
			},
			getTokenNew(userId) {
				this.$post(
					this.$login + '/Token/GenerateTokenAsync', {
						"userId": userId,
						"orgId": this.$organizationId,
						"key": this.$md5(userId + "|@Sweet0ur2016-@Sweet0ur2024")
					}
				).then(res => {
					this.setUserTokenNew('Bearer ' + res.data)
				})
			},
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		}
	}
</script>

<style scoped>
	.login-popup {
		width: 650px;
	}

	.login-container {
		padding: 30px 40px 40px;
		box-sizing: border-box;
	}

	.login-header {
		text-align: center;
		margin-bottom: 40px;
	}

	.login-header img {
		width: 280px;
	}

	.login-form {
		width: 100%;
	}

	.login-field {
		margin-bottom: 24px;
	}

	.login-field p {
		font-size: 26px;
		color: #333;
		margin-bottom: 12px;
	}

	.login-field input {
		width: 100%;
		height: 80px;
		border: 1px solid #eee;
		border-radius: 8px;
		padding: 0 20px;
		box-sizing: border-box;
		font-size: 26px;
	}

	.code-field .code-input {
		display: flex;
		align-items: center;
	}

	.code-field input {
		flex: 1;
	}

	.code-btn {
		margin-left: 16px;
		width: 160px;
		height: 80px;
		border-radius: 8px;
		border: 1px solid #ff7e2d;
		background-color: #fff;
		color: #ff7e2d;
		font-size: 24px;
	}

	.login-btn {
		margin-top: 20px;
		width: 100%;
		height: 88px;
		border-radius: 44px;
		border: none;
		background-color: #ff7e2d;
		color: #fff;
		font-size: 30px;
	}

	.login-agree {
		margin-top: 20px;
		font-size: 22px;
		color: #999;
	}

	.login-agree label {
		display: flex;
		align-items: center;
	}

	.login-agree input {
		margin-right: 8px;
	}

	.login-cancel {
		margin-top: 20px;
		text-align: center;
		font-size: 24px;
		color: #ff3b30;
	}
</style>